'use client';
import React from 'react';
import AppLayout from '@/components/AppLayout';
import MatchRoomContent from './components/MatchRoomContent';

export default function MatchPage() {
  return (
    <AppLayout activePath="/match">
      <MatchRoomContent />
    </AppLayout>
  );
}
